var exports = {
  "Kk": "CallMessage.module__icon___UlJQeE",
  "mR": "CallMessage.module__iconActive___UlJQeE",
  "Ap": "CallMessage.module__iconEnded___UlJQeE",
  "bp": "CallMessage.module__iconMissed___UlJQeE",
  "x": "CallMessage.module__callLink___UlJQeE",
};

module.exports = exports;
